import { ListGameMobile } from '../../../component/ListGameMobile'
import { useNavigate } from 'react-router-dom'
import { DangKyDangNhapMobile } from '../../DangKyDangNhapMobile'
import { useState } from 'react'

function BanCa () {
  const navigate = useNavigate()
  const [tab, settab] = useState('')
  const [isOpen, setisOpen] = useState(false)
  const dangnhap = localStorage.getItem('dangnhap')
  const data = [
    {
      name: 'JILI',
      logo: '/mobile/banca/logojili.png',
      img: '/mobile/banca/anhjili.webp',
      first: 'lifirst',
      classimage: 'anh_item_first',
      firm_logo: 'firm_logo2'
    },
    {
      name: 'JDB',
      logo: '/mobile/banca/logojdb.png',
      img: '/mobile/banca/anhjdb.webp',
      first: '',
      classimage: '',
      firm_logo: ''
    },
    {
      name: 'FC',
      logo: '/mobile/banca/logofc.png',
      img: '/mobile/banca/anhfc.webp',
      first: '',
      classimage: '',
      firm_logo: ''
    }
  ]
  return (
    <>
      <ListGameMobile>
        <ul className='ulthethao'>
          {data.map((item, index) => (
            <li
              className={`thethao_item ${item.first}`}
              key={index}
              style={{ background: 'url(/mobile/banca/backbanca.png)' }}
              onClick={() => {
                if (!dangnhap) {
                  setisOpen(true)
                  settab('Đăng nhập')
                } else {
                  navigate(`/game_list_mobile?tab=${item.name}&game=banca`)
                }
              }}
            >
              <div className='gameitem'>
                <div className={`firm_logo ${item.firm_logo}`}>
                  <i>
                    <img src={item.logo} alt='' />
                  </i>
                </div>
                <div
                  style={{ backgroundImage: `url(${item.img})` }}
                  className={`anhgame ${item.classimage}`}
                ></div>
                <div className='gametag'></div>
              </div>
            </li>
          ))}
        </ul>
      </ListGameMobile>
      <DangKyDangNhapMobile
        tab={tab}
        settab={settab}
        isOpen={isOpen}
        onClose={() => setisOpen(false)}
      />
    </>
  )
}

export default BanCa
